import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormsCircleSquare: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="forms-circle-square, shapes, designs, templates"><path d="M17.75 8.75H20.25V20.25H8.75V17.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><circle cx="9" cy="9" r="6.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
};

export default IconFormsCircleSquare;
